import { LineChart } from '@tremor/react';
import { ChartConfig } from './types';
import { AvailableChartColors } from '../../lib/chartUtils';

interface CindraLineChartProps {
    config: ChartConfig;
}

export function CindraLineChart({ config }: CindraLineChartProps) {
    const valueFormatter = config.valueFormatter
        ? (new Function('value', `return ${config.valueFormatter}`) as (value: number) => string)
        : undefined;

    return (
        <div className="w-full">
            <LineChart
                categories={config.categories}
                className="h-80"
                colors={AvailableChartColors}
                connectNulls={true}
                data={config.data}
                index={config.index}
                showAnimation={false}
                showLegend={config.categories.length > 1}
                valueFormatter={valueFormatter}
                yAxisWidth={56}
            />
        </div>
    );
}
